/**
 * What the guide is doing right now, in words a visitor would use.
 *
 * A tool name never reaches the screen — that is a product invariant, not a
 * preference (PRODUCT-INVARIANTS.md; the graph has `guard.scrub_tool_names`
 * doing the same job on the prose side). An unknown name is «Ищу…» rather than
 * itself, so a tool added tomorrow degrades to a vague line instead of leaking
 * `afisha_event_details` into the interface.
 */

const LABELS: Record<string, string> = {
  search_knowledge: 'Читаю материалы музея…',
  object_info: 'Смотрю каталог…',
  list_objects: 'Смотрю каталог…',
  find_nearby: 'Ищу, что рядом…',
  schedule_on_date: 'Проверяю расписание…',
  ticket_prices: 'Уточняю цены…',
  how_to_get_there: 'Смотрю, как добраться…',
  route_walk: 'Собираю маршрут…',
  afisha_events: 'Открываю афишу…',
  afisha_event_details: 'Открываю афишу…',
  park_weather: 'Смотрю погоду…',
  audio_tours: 'Ищу аудиогид…',
  audio_tour: 'Ищу аудиогид…',
  plan_get: 'Обновляю ваш план…',
  plan_set: 'Обновляю ваш план…',
  plan_remove: 'Обновляю ваш план…',
  plan_clear: 'Обновляю ваш план…',
  profile_update: 'Записываю…',
  record_feedback: 'Записываю…',
  forget_me: 'Записываю…',
  suggest_chips: 'Подбираю, что спросить дальше…',
};

const FALLBACK = 'Ищу…';

export function toolLabel(name: string): string {
  return LABELS[name] ?? FALLBACK;
}

/**
 * One line for a whole batch of calls: repeated labels collapse, because
 * «Смотрю каталог… Смотрю каталог…» reads as a stutter rather than as progress.
 */
export function toolLabelsFor(names: readonly string[]): string[] {
  const seen: string[] = [];
  for (const name of names) {
    const label = toolLabel(name);
    if (!seen.includes(label)) seen.push(label);
  }
  return seen;
}
